import { render } from "./LandingPage.vue?vue&type=template&id=c68c3c4e&scoped=true&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=c68c3c4e&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68c3c4e"]])

export default __exports__